import { useEffect, useState } from 'react';
import { Upload, Building2, User, MapPin, Users, DollarSign, Wrench, Car, Shield, AlertCircle, Plus, X } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '../../components/ui/card';
import { Input } from '../../components/ui/input';
import { Label } from '../../components/ui/label';
import { Button } from '../../components/ui/button';
import { Checkbox } from '../../components/ui/checkbox';
import { Textarea } from 'components/ui/textarea';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { selectToken } from 'slices/auth/login/reducer';
import { trackEvent } from 'pages/creditCardProcessing';

interface Vehicle {
  id: string;
  yearMakeModel: string;
  vin: string;
  driverName: string;
  driverDOB: string;
  driverLicense: string;
}

export default function App() {
  const [formData, setFormData] = useState({
    legalBusinessName: '',
    dba: '',
    entityType: '',
    yearsInBusiness: '',
    businessAddress: '',
    phone: '',
    email: '',
    ownerName: '',
    dateOfBirth: '',
    buildingType: '',
    roofLastReplaced: '',
    yearPurchased: '', // New field for when building is owned
    primaryTrade: '',
    commercialPercent: '',
    residentialPercent: '',
    subcontractorsUsed: '',
    percentSubcontracted: '',
    subcontractorNames: '', // New field for subcontractor details
    subcontractorInsured: '', // New field to track if subs are insured
    annualGrossReceipts: '',
    numberOfEmployees: '',
    annualPayroll: '',
    workersCompNeeded: '',
    miscToolsValue: '',
    highValueEquipment: '',
    commercialAuto: 'No',
    currentCarrier: '',
    currentLimits: '',
    currentAnnualPremium: '',
    claimsInLast5Years: '',
    claimsDescription: ''
  });

  const [vehicles, setVehicles] = useState<Vehicle[]>([]);

  const addVehicle = () => {
    const newVehicle: Vehicle = {
      id: Date.now().toString(),
      yearMakeModel: '',
      vin: '',
      driverName: '',
      driverDOB: '',
      driverLicense: ''
    };
    setVehicles([...vehicles, newVehicle]);
  };

  const removeVehicle = (id: string) => {
    setVehicles(vehicles.filter(v => v.id !== id));
  };

  const updateVehicle = (id: string, field: keyof Vehicle, value: string) => {
    setVehicles(vehicles.map(v => 
      v.id === id ? { ...v, [field]: value } : v
    ));
  };



  const handleInputChange = (field: string, value: string) => {
    setFormData(prev => ({ ...prev, [field]: value }));
  };
  const navigate= useNavigate()
  const token = useSelector(selectToken)
   useEffect(()=>{
 window.open("https://www.thetradesmensinsurance.com/","blank")
 navigate("/")
 trackEvent("P C and Workers Comp", {}, "property_insurance",token)
   },[])
  return (
    <div className='tailwind-prefix page-content'>
 
    </div>

  );
}